import type { SxStyle } from '@aibees/shared/theme';

export const root: SxStyle = {
  width: '100%',
};

export const card: SxStyle = {
  width: '100%',
  textAlign: 'center',
  borderRadius: (p) => p.spacing(1),
  padding: (p) => p.spacing(0.75, 1),
  backgroundColor: (p) =>
    p.palette.mode === 'light'
      ? p.palette.grey[200]
      : p.palette.background.paper,
};
